import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { ExportCollectionReportService } from '../../../services/export-collection-report.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-export-collection-report',
  templateUrl: './export-collection-report.component.html',
  styleUrls: ['./export-collection-report.component.css']
})
export class ExportCollectionReportComponent implements OnInit {
  modalService: ModalService;

  filter: any = {
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
  };

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;


  constructor(authService: AuthService, public exportCollectionReportService: ExportCollectionReportService, public router: Router, modalService: ModalService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;
   
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    this.loadTable(this.page);

  }

  ngOnInit() {
    this.loadTable(this.page);
    this.init = true;
  }

  outOfService() {
    console.log(this.filter.out_Of_Service)
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    console.log("Attempting to Load Table");
    this.exportCollectionReportService.getResults(this.page, this.filter.start_Date, this.filter.end_Date).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

      for (let i = 0; i < this.rows.length; i++) {
        const coL_START_TIME = moment(this.rows[i].coL_START_TIME, "YYYY-MM-DD hh:mm:ss");
        this.rows[i].coL_START_TIME = coL_START_TIME.format("DD/MM/YYYY");

        const deL_START_TIME = moment(this.rows[i].deL_START_TIME, "YYYY-MM-DD hh:mm:ss");
        this.rows[i].deL_START_TIME = deL_START_TIME.format("DD/MM/YYYY");
      }

      console.log(pagedData);
      console.log(this.page);
      console.log(this.rows); 

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.exportCollectionReportService.getExcel(this.filter.start_Date, this.filter.end_Date).then((data) => {
        importedSaveAs(data, 'collection.xlsx');
      });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}

